import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Button, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import BlockUi from "react-block-ui";
import Loader from "react-loaders";
import { loaderMsg, loadertype } from "../../constants";

const options = {
  sortIndicator: true,
  paginationSize: 3,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function SalesItemsBody({ deleteClick, wait, footValues, handleSelectedRows, sendSelectedRows, loadData, updateUnitRow }) {
  const renderActionButtons = (cell, row, rowIndex) => (
    <span>
      <Button
        className="btn btn-danger"
        id={`delete-${rowIndex}`}
        onClick={() => deleteClick(row)}
      >
        <i className="fa fa-minus-circle" />
      </Button>
      <UncontrolledTooltip placement="right" target={`delete-${rowIndex}`}>
        Remove
      </UncontrolledTooltip>
    </span>
  );

  const renderTableHeaderColumn = (dataField, headerText, filter = true, enable = false) => (
    <TableHeaderColumn
      dataField={dataField}
      filter={filter ? { type: "TextFilter", delay: 1000 } : undefined}
      tdStyle={{ whiteSpace: "normal" }}
      thStyle={{ whiteSpace: "normal" }}
      editable={enable}
    >
      {headerText}
    </TableHeaderColumn>
  );

  const onRowSelect = (row, isSelected, e) => {
    handleSelectedRows(rows => {
      if (isSelected) {
        return [...rows, row];
      } else {
        return rows.filter(r => r.id !== row.id);
      }
    });
  }

  const onSelectAll = (isSelected, rows) => {
    handleSelectedRows(isSelected ? rows : []);
  }

  const selectRowProp = {
    mode: 'checkbox',
    //   clickToSelect: true,
    onSelect: onRowSelect,
    onSelectAll: onSelectAll
  };

  // Store original row data before editing

  const onBeforeSaveCell = (row, cellName, cellValue) => {
    swal({
      text: "Are you sure you want to save the changes?",
      buttons: ["Cancel", "Yes, save it!"],
    }).then((willSave) => {
      if (willSave) {
        return true
      } else {
        let obj = { billNumber: row.invoiceNumber };
        loadData(obj);
        return false;
      }
    });

  }

  const onAfterSaveCell = (row, cellName, cellValue) => {
    updateUnitRow(row);


  }

  const cellEditProp = {
    mode: 'dbclick',
    blurToSave: true,
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    afterSaveCell: onAfterSaveCell  // a hook for after saving cell
  };


  // Custom styles for the Delete button
  const deleteBtnStyle = {
    backgroundColor: "#e74c3c",
    borderColor: "#e74c3c",
    color: "#fff",
    fontWeight: "bold",
    letterSpacing: "0.5px",
    padding: "8px 20px",
    borderRadius: "4px",
    boxShadow: "0 2px 6px rgba(231,76,60,0.15)",
    marginBottom: "15px"
  };

  return (
    <BlockUi
      tag="div"
      blocking={wait}
      loader={<Loader active type={loadertype} color="#8dc63f" />}
      message={loaderMsg}
    >
      <Card>
        <CardBody>
          <Button
            className="btn btn-primary"
            style={deleteBtnStyle}
            onClick={sendSelectedRows}
          >
            Delete
          </Button>
          <div className="table-responsive">
            <BootstrapTable
              data={footValues.saleItems || []}
              version="4"
              condensed
              striped
              hover
              pagination
              options={options}
              selectRow={selectRowProp}
              cellEdit={cellEditProp}
            >
              <TableHeaderColumn isKey dataField="id" hidden>
                ID
              </TableHeaderColumn>
              {renderTableHeaderColumn("productCode", "Product Code")}
              {renderTableHeaderColumn("productDescription", "Product Description")}
              {renderTableHeaderColumn("mrp", "MRP")}
              {renderTableHeaderColumn("units", "Units", true, true)}
              {renderTableHeaderColumn("grossSalesAmt", "Gross Sales")}
              {renderTableHeaderColumn("totalDiscount", "Total Discount")}
              {renderTableHeaderColumn("taxableAmt", "Taxable Amt")}
              {renderTableHeaderColumn("sgstAmt", "SGST Amt")}
              {renderTableHeaderColumn("cgstAmt", "CGST Amt")}
              {renderTableHeaderColumn("igstAmt", "IGST Amt", false)}
              {renderTableHeaderColumn("totalTax", "Total Tax")}
              {renderTableHeaderColumn("netSales", "Net Sales")}
              <TableHeaderColumn
                dataField="button"
                dataFormat={renderActionButtons}
                export={false}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </CardBody>
      </Card>
    </BlockUi>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesItemsBody.js